import { render, staticRenderFns } from "./CampoDuracionContrato.vue?vue&type=template&id=21ec1fc7"
import script from "./CampoDuracionContrato.vue?vue&type=script&lang=js"
export * from "./CampoDuracionContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports